import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from '../Button/Button.js';
import { Spinner } from '../Spinner/Spinner.js';
export function StepUpInterstitial({ workspaceName, stepUpUrl, onCancel, }) {
    React.useEffect(() => {
        if (!stepUpUrl)
            return;
        const t = window.setTimeout(() => {
            window.location.href = stepUpUrl;
        }, 500);
        return () => window.clearTimeout(t);
    }, [stepUpUrl]);
    const handleVerify = React.useCallback(() => {
        if (stepUpUrl)
            window.location.href = stepUpUrl;
    }, [stepUpUrl]);
    return (_jsxs("main", { "data-step-up-interstitial": true, style: {
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'var(--space-4)',
            padding: 'var(--space-8) var(--space-6)',
            fontFamily: 'var(--font-ui)',
            color: 'var(--text)',
            textAlign: 'center',
        }, children: [_jsx(Spinner, { size: 32, label: "Redirecting to identity provider" }), _jsx("h1", { style: { margin: 0, fontSize: 'var(--font-size-lg)', color: 'var(--text)' }, children: "Verifying with your identity provider" }), _jsxs("p", { "aria-live": "polite", style: { margin: 0, maxWidth: '52ch', color: 'var(--text-muted)' }, children: [workspaceName, " requires multi-factor authentication. You\u2019ll be sent to your identity provider to verify \u2014 should take about 15 seconds."] }), _jsxs("div", { style: { display: 'inline-flex', gap: 'var(--space-3)', marginTop: 'var(--space-2)' }, children: [_jsx(Button, { variant: "primary", onClick: handleVerify, disabled: !stepUpUrl, children: stepUpUrl ? 'Verify now' : 'Preparing verification…' }), onCancel ? (_jsx(Button, { variant: "ghost", onClick: onCancel, children: "Sign out" })) : null] })] }));
}
//# sourceMappingURL=StepUpInterstitial.js.map